import { useFormikContext } from 'formik'

import { ExpandableList } from './expandable-list.component'
import { useScanRelationContext } from '../form-wrapper/relations-context.component'
import { useStyles } from '../styles'

import {
  ECreateScanMode,
  EScanRecordType,
  ETranslationNs,
  IScanCreateForm,
  IScanProductImpact,
  IScanProductImpactsRespDto,
  IStepByIdRawRespDto,
  IStepsAllRawRespDto,
} from 'src/types'
import { ChangeEvent, useState } from 'react'
import { useScanProductImpacts, useScanSteps } from 'src/hooks'
import { SearchBar } from 'src/components/search-bar'
import { useTranslation } from 'react-i18next'
import { Box } from '@mui/material'

export const ThirdProgression = () => {
  const [search, setSearch] = useState('')
  // const [searchImpact, setSearchImpact] = useState('')

  const [t] = useTranslation(ETranslationNs.ScanForm)
  const classes = useStyles()

  const { setRelations, step, setStep, relations, setCreateScanMode, setFormType } =
    useScanRelationContext()
  const { values, setFieldValue } = useFormikContext<IScanCreateForm>()

  const { data: steps, isLoading: isStepsLoading } = useScanSteps(
    values.product_id,
    { query: search },
    values.account_id,
  )

  const { data: impacts, isLoading: isImpactsLoading } = useScanProductImpacts(
    values.product_id,
    { query: search },
    values.account_id,
  )

  if (step !== 2) {
    return null
  }

  const handleSelectProductScanItem = (item: IStepByIdRawRespDto) => {
    setRelations((prev) => ({ ...prev, step: item, impact: null }))
    setFormType(EScanRecordType.General)
    setFieldValue('impact_id', null)
    setFieldValue('step_id', item.id)
    setCreateScanMode(ECreateScanMode.Default)
    setStep(3)
  }

  const handleSelectProductImpactItem = (item: IScanProductImpact) => {
    setRelations((prev) => ({ ...prev, impact: item, step: null }))
    setFormType(EScanRecordType.Impact)
    setFieldValue('step_id', null)
    setFieldValue('impact_id', item.id)
    setCreateScanMode(ECreateScanMode.ProductImpact)
    setStep(3)
  }

  const handleSearchChange = (e: ChangeEvent<HTMLInputElement>) => {
    const query = e.target.value
    setSearch(query)
  }

  return (
    <div className={classes.sectionWrapper}>
      <Box
        sx={{
          maxWidth: 900,
          height: 'inherit',

          display: 'flex',
          flexDirection: 'column',
          mb: '8px',
        }}
      >
        <SearchBar
          handleSearchChange={handleSearchChange}
          search={search}
          inputPlaceholder={t('scan-steps-search.v')}
        />
      </Box>

      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          gap: '8px',
          width: '100%',
          maxWidth: 900,
          mb: '32px',
        }}
      >
        <ExpandableList<IStepByIdRawRespDto, IStepsAllRawRespDto>
          label={t('create-scan-steps-lable.v')}
          notFoundLable={t('scan-form-no-steps-msg.v')}
          selectedItem={values.step_id || ''}
          handleSelectItem={handleSelectProductScanItem}
          items={steps}
          isLoading={isStepsLoading}
          isOpened={!!values.step_id}
          isOpenedByDefault
        />

        <ExpandableList<IScanProductImpact, IScanProductImpactsRespDto>
          label={t('create-scan-impacts-lable.v')}
          notFoundLable={t('scan-form-no-product-impacts-msg.v')}
          selectedItem={values.impact_id || ''}
          handleSelectItem={handleSelectProductImpactItem}
          items={impacts}
          isLoading={isImpactsLoading}
          isOpened={!!values.impact_id}
          isOpenedByDefault
        />
      </Box>
    </div>
  )
}
